/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_RemoveInputs */

const en_admin_footer_badges_remove = /** @type {(inputs: Admin_Footer_Badges_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Admin_Footer_Badges_RemoveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_remove = /** @type {((inputs?: Admin_Footer_Badges_RemoveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_RemoveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_remove(inputs)
});
export { admin_footer_badges_remove as "admin.footer_badges.remove" }